import DateComparisonPeriod from './DateComparisonPeriod';

import './_date-comparison-period.scss';

export default DateComparisonPeriod;
